import { receiveData}  from '../api/http'

export const PLAY_VIDEO  = 'PLAY_VIDEO'
export const PAUSE_VIDEO = 'PAUSE_VIDEO'
export const STOP_VIDEO  = 'STOP_VIDEO'

export const PLAY_PENDING  = 'PLAY_PENDING'
export const PLAY_SUCCESS  = 'PLAY_SUCCESS'
export const PLAY_ERROR    = 'PLAY_ERROR'

export const play_file = (cloud_account_id, bucket_name, file_name) => dispatch => dispatch(receiveData(PLAY_SUCCESS, {cloud_account_id, bucket_name, file_name}))

export const stop_video = () => dispatch => dispatch(receiveData(STOP_VIDEO,{}))
